import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Button, Form, Radio, Select } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FormActions, FormActionsRight, StyledSelectWrapper } from './MultiSorter.style';

const MAX_SORT_COLUMNS = 6;

export function MultiSorter({ columnDefs = [], multiSortDef, onClose }) {
  const { t } = useTranslation();
  const [sorts, setSorts] = useState(getInitialSort());
  const sortedKeys = sorts.map(s => s.key).filter(Boolean);
  const availableColumns = columnDefs.filter(
    col => col.sorter && col.get && !sortedKeys.includes(col.key)
  );

  function getSortDefault() {
    return [...Array(MAX_SORT_COLUMNS)].map(_ => ({ key: undefined, sort: 'ASC' }));
  }

  function getInitialSort() {
    const sortDefaults = getSortDefault();
    return multiSortDef
      ? sortDefaults.map((sort, idx) => {
          if (multiSortDef[idx]) {
            return { key: multiSortDef[idx].column.key, sort: multiSortDef[idx].sortDirection };
          }
          return sort;
        })
      : sortDefaults;
  }

  function handleStateUpdate(value, index, key) {
    setSorts(prevSorts =>
      prevSorts.map((sort, idx) => {
        return idx === index
          ? {
              ...sort,
              [key]: value,
            }
          : sort;
      })
    );
  }

  function handleSave() {
    const sortedColumns = sorts.filter(sort => sort.key);
    onClose({ sortedColumns });
  }

  function handleReset() {
    setSorts(getSortDefault());
  }

  const columnLabels = columnDefs.reduce((obj, col) => {
    if (col.key) {
      obj[col.key] = col.title;
    }

    return obj;
  }, {});

  return (
    <>
      <Form>
        {sorts.map((s, index) => {
          return (
            <StyledSelectWrapper key={index}>
              <label htmlFor={`sort-col-${index}`}>{t('table.sortBy', 'Sort by')}:</label>
              <Select
                id={`sort-col-${index}`}
                allowClear={index === sorts.length - 1 || !sorts[index + 1].key}
                placeholder={t('components.column', 'Column')}
                style={{ width: '100%' }}
                value={columnLabels[sorts[index].key]}
                onChange={value => handleStateUpdate(value, index, 'key')}
                disabled={index > 0 && !sorts[index - 1].key}
                options={availableColumns.map(col => ({ value: col.key, label: col.title }))}
              />
              <Radio.Group
                style={{ width: '120px' }}
                disabled={!s.key}
                onChange={e => handleStateUpdate(e.target.value, index, 'sort')}
                defaultValue={'ASC'}
                value={sorts[index].sort}
              >
                <Radio.Button value="ASC">
                  <CaretUpOutlined />
                </Radio.Button>
                <Radio.Button value="DESC">
                  <CaretDownOutlined />
                </Radio.Button>
              </Radio.Group>
            </StyledSelectWrapper>
          );
        })}
        <FormActions>
          <Button onClick={handleReset}>{t('table.reset', 'Reset')}</Button>
          <FormActionsRight>
            <Button onClick={onClose}>{t('common.cancel', 'Cancel')}</Button>
            <Button type="primary" onClick={handleSave} data-testid="multi-sort-btn">
              {t('common.save', 'Save')}
            </Button>
          </FormActionsRight>
        </FormActions>
      </Form>
    </>
  );
}
